'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _PictureAsPdf = _interopRequireDefault(require("@material-ui/icons/PictureAsPdf"));
var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));
var _EnhancedTableHead = _interopRequireDefault(require("Components/Lists/EnhancedTableHead"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _Link = _interopRequireDefault(require("Pure/Link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
_moment.default.locale('fr');
let app = window.app;
const sectors_default_options = [{
  value: 'all',
  label: 'Tous les secteurs'
}];
const professional_domain_default_options = [{
  value: 'all',
  label: 'Tous les domaines'
}];
const formation_level_options = [{
  value: 'all',
  label: 'Tous les niveaux'
}, {
  value: "CAP",
  label: "CAP"
}, {
  value: "BAC",
  label: "BAC"
}, {
  value: "Master",
  label: "Master"
}, {
  value: "Doctorat",
  label: "Doctorat"
}, {
  value: "Formation professionnelle",
  label: "Formation professionnelle"
}, {
  value: "Autre",
  label: "Autre"
}];
const columns = [{
  id: 'lastname',
  sortable: false,
  numeric: false,
  label: 'Nom du candidat',
  center: true
}, {
  id: 'login',
  sortable: false,
  numeric: false,
  label: 'E-mail',
  center: true
}, {
  id: 'professional_domain',
  sortable: false,
  numeric: false,
  label: 'Domaine professionnel',
  center: true
}, {
  id: 'formation',
  sortable: false,
  numeric: false,
  label: 'Niveau de formation',
  center: true
}, {
  id: 'actions',
  sortable: false,
  numeric: false,
  label: 'Visualiser le CV',
  center: true
}];
class Cvs extends _react.Component {
  state = {
    selected: [],
    cvs: [],
    cvs_count: 0,
    page: 0,
    rows_per_page: 25,
    searched_name: '',
    order: 'desc',
    order_by: 'created_at',
    status_messages: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (app.state.session?.user?.id) {
      component.setSectorInState();
    }
    app.push({
      event: 'sessionChange',
      cb: component.setSectorInState
    });
    component.fetchSectors();
    component.fetchCandidates();
    component.fetchProfessionalDomain();
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.setSectorInState
    });
  }
  fetchSectors = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/sector/get-all').then(function (xhr, response) {
      component.setState({
        sectors: response.sectors,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  setSectorInState = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const user_sector = app.state.session?.user?.sector;
    const user_roles = app.state.session?.user?.roles;
    if (user_roles.includes('admin') || user_roles.includes('super_admin') || user_roles.includes('accompanist')) {
      component.setState({
        sectors_filter: 'all'
      });
      component.fetchCvs({
        sectors_filter: 'all'
      });
    } else {
      component.setState({
        sectors_filter: user_sector || 'all'
      });
      component.fetchCvs({
        sectors_filter: user_sector || 'all'
      });
    }
  };
  fetchCvs = _ref => {
    let {
      page,
      order,
      order_by,
      sectors_filter,
      searched_name,
      professional_domain_filter,
      formation_level_filter
    } = _ref;
    const component = this,
      props = this.props,
      state = this.state;
    page = typeof page === 'undefined' ? state.page : page;
    order = order || state.order;
    order_by = order_by || state.order_by;
    component.setState({
      loading: true
    });
    const user_roles = app.state.session?.user?.roles;
    const user_id = app.state.session?.user?.id;
    qwest.post('/cv/get-all', {
      limit: state.rows_per_page,
      skip: state.rows_per_page * page,
      with_count: true,
      user_id: user_id,
      user_roles: user_roles,
      order: order,
      order_by: order_by,
      sectors_filter: sectors_filter || state.sectors_filter,
      searched_name: searched_name || state.searched_name,
      professional_domain_filter: professional_domain_filter || state.professional_domain_filter,
      formation_level_filter: formation_level_filter || state.formation_level_filter,
      enriched: true
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        cvs: response.cvs,
        cvs_count: response.count
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchCandidates = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/candidate/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        candidates: response.candidates
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchProfessionalDomain = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/professional-domain/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        professional_domains: response.professional_domains
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  getProfessionalDomainLabel = professional_domain_id => {
    const component = this,
      props = this.props,
      state = this.state;
    let professional_domain = (state.professional_domains || []).find(professional_domain => professional_domain_id === professional_domain.id);
    return professional_domain?.label;
  };
  handleChangePage = (e, page) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      page: page
    });
    component.fetchCvs({
      page: page
    });
  };
  handleFilterChange = _ref2 => {
    let {
      e,
      value,
      name
    } = _ref2;
    const component = this,
      props = this.props,
      state = this.state;
    if (e === null) return;
    component.setState({
      [name]: value
    });
    component.fetchCvs({
      [name]: value
    });
  };
  handleRequestSort = (e, column) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    const order_by = column.id;
    let order = 'desc';
    if (state.order_by === order_by && state.order === 'desc') {
      order = 'asc';
    }
    component.setState({
      order: order,
      order_by: order_by,
      loading: true
    });
    component.fetchCvs({
      order: order,
      order_by: order_by
    });
  };
  handleSearchChange = _ref3 => {
    let {
      e,
      value,
      name
    } = _ref3;
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      searched_name: value
    });
    if (component.timeout) window.clearTimeout(component.timeout);
    component.timeout = window.setTimeout(function () {
      component.timeout = undefined;
      component.fetchCvs({
        searched_name: value
      });
    }, 800);
  };
  getSearchedContractLabel = searched_contracts => {
    let searched_contracts_label = (Object.keys(searched_contracts) || []).map(function (searched_contract) {
      let label;
      if (searched_contract === "alternance" && searched_contracts[searched_contract] === true) {
        label = "Alternance";
      } else if (searched_contract === "cdd" && searched_contracts[searched_contract] === true) {
        label = "CDD";
      } else if (searched_contract === "cdi" && searched_contracts[searched_contract] === true) {
        label = "CDI";
      } else if (searched_contract === "stage" && searched_contracts[searched_contract] === true) {
        label = "Stage";
      }
      return label + ' ';
    });
    return searched_contracts_label;
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const empty_rows = state.rows_per_page - Math.min(state.rows, state.cvs_count - state.page * state.rows_per_page);
    _moment.default.locale('fr');
    const professional_domain_options = (state.professional_domains || []).map(function (domain) {
      let option = {
        label: domain.label,
        value: domain.id
      };
      return option;
    });
    professional_domain_options.sort((a, b) => {
      const nameA = a.label;
      const nameB = b.label;
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    const rows = (state.cvs || []).map(function () {
      let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const link = /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: '/liste-des-cvs/' + data.candidate_id,
        className: "u-link-only"
      });
      let formation_level = (data.formation || []).map(function (formation, index) {
        let output = /*#__PURE__*/_react.default.createElement("span", {
          className: "u-padding-right-5",
          key: index
        }, formation.level);
        return output;
      });
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        tabIndex: -1,
        key: data.id
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, [data.__candidate?.firstname || '', data.__candidate?.lastname || ''].join(' '), link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.__candidate?.login, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.__candidate?.__professional_domain?.label, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, formation_level, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        href: "/candidats/" + data.id,
        color: "primary",
        variant: "contained",
        target: "_blank",
        className: "u-padding-10 u-margin-right-10 u-text-center",
        component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props)
      }, /*#__PURE__*/_react.default.createElement(_Visibility.default, null))));
      return output;
    });
    const sector_options = (state.sectors || []).map(function (sector) {
      let option = {
        label: sector.name,
        value: sector.id
      };
      return option;
    });
    const filter = state.sectors ? /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.sectors_filter,
      className: "u-padding-10",
      name: "sectors_filter",
      status: state.status_messages,
      options: sectors_default_options.concat(sector_options),
      "default-value": sectors_default_options[0].value,
      label: "Secteur"
    }) : undefined;
    const user_roles = app.state.session?.user?.roles;
    let output = /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "dashboard-table"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "dashboard-filter"
    }, user_roles.includes('admin') ? filter : undefined, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleSearchChange,
      className: "u-padding-10 u-full-width",
      name: "searched_name",
      label: "Recherche par nom",
      status: state.status_messages,
      value: state.searched_name
    }), state.professional_domains ? /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.professional_domain_filter,
      className: "u-padding-10",
      name: "professional_domain_filter",
      status: state.status_messages,
      options: professional_domain_default_options.concat(professional_domain_options),
      "default-value": professional_domain_default_options[0].value,
      label: "Domaine professionnel"
    }) : undefined, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.formation_level_filter,
      className: "u-padding-10",
      name: "formation_level_filter",
      status: state.status_messages,
      options: formation_level_options,
      "default-value": formation_level_options[0].value,
      label: "Niveau de formation"
    })), /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-labelledby": "Candidats"
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      onRequestSort: component.handleRequestSort,
      order: state.order,
      order_by: state.order_by,
      row_count: rows.length,
      columns: columns
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, rows, empty_rows > 0 ? /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      style: {
        height: 49 * empty_rows
      }
    }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      colSpan: 4
    })) : undefined)), /*#__PURE__*/_react.default.createElement(_TablePagination.default, {
      onChangePage: component.handleChangePage,
      component: "div",
      count: state.cvs_count,
      rowsPerPage: state.rows_per_page,
      rowsPerPageOptions: [],
      page: state.page,
      backIconButtonProps: {
        'aria-label': 'Page précédente'
      },
      nextIconButtonProps: {
        'aria-label': 'Page suivante'
      },
      labelDisplayedRows: _ref4 => {
        let {
          from,
          to,
          count
        } = _ref4;
        return from + '-' + to + ' sur ' + count;
      }
    }));
    return output;
  }
}
exports.default = Cvs;
